import React, {FC} from "react"
import {Row, Col} from "react-bootstrap"

import {Deal} from "@irati/types"

import {H2, H4} from "@irati/ui/src/Typography"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import img404 from "@irati/ui/images/deal-404.svg"
import {FormattedMessage} from "@irati/utils/lang"

import DealStatus from "@irati/deals/constants/status"
import StyledStatusContainer from "./styled/Container"
import StyledImg from "./styled/Img"
import Card from "./styled/Card"

interface Props {
  deal?: Deal | null
}

const RequireDealStatusOn: FC<Props> = ({deal, children}) => {
  const dealStatus = deal?.status
  const dealStatusVisible = [DealStatus.ON, DealStatus.TEST, DealStatus.UNAVAILABLE].indexOf(dealStatus) >= 0

  return (
    <div>
      {dealStatusVisible && children}

      {!dealStatusVisible && (
        <StyledStatusContainer>
          <Row>
            <Col md={8} mdOffset={2}>
              <Card>
                <StyledImg src={img404} alt="Perk not available" />
                {(() => {
                  switch (dealStatus) {
                    case DealStatus.OFF:
                      return (
                        <span>
                          <H2>
                            <FormattedMessage id="perks.components.requireDealStatus.error.firstText" /><br />
                            <FormattedMessage id="perks.components.requireDealStatus.error.notAvailable" />
                          </H2>
                        </span>
                      )
                    case DealStatus.HIDDEN:
                      return (
                        <span>
                          <H2>
                            <FormattedMessage id="perks.components.requireDealStatus.error.firstText" /><br />
                            <FormattedMessage id="perks.components.requireDealStatus.error.tempUnavailableTitle" />
                          </H2>
                          <H4><FormattedMessage id="perks.components.requireDealStatus.error.tempUnavailableDesc" /></H4>
                        </span>
                      )
                    default:
                      return (
                        <span>
                          <H2>
                            <FormattedMessage id="perks.components.requireDealStatus.error.firstText" /><br />
                            <FormattedMessage id="perks.components.requireDealStatus.error.notFoundTitle" />
                          </H2>
                          <H4><FormattedMessage id="perks.components.requireDealStatus.error.notFoundDesc" /></H4>
                        </span>
                      )
                  }
                })()}
                <ButtonRouterLink primary to="/">
                  <FormattedMessage id="perks.components.requireDealStatus.allPerksButton" />
                </ButtonRouterLink>
              </Card>
            </Col>
          </Row>
        </StyledStatusContainer>
      )}
    </div>
  )
}

export default RequireDealStatusOn
